import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { LoadingScreen } from 'src/components/loading-screen';
import { useStores } from 'src/models';
import { PATH_PAGE } from 'src/routes/paths';

type GuestGuardProps = {
  children: ReactNode;
};

function GuestGuard({ children }: GuestGuardProps) {
  const { authStore } = useStores();
  const { isInitialized, isAuthenticated } = authStore;

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    // 로그인 성공 후에는 항상 홈으로 이동 (이전 경로 복원 X)
    return <Navigate to={PATH_PAGE.home} replace />;
  }

  return <>{children}</>;
}

export default observer(GuestGuard);
